import React from 'react';

import TableLoader from '@dashboard/components/table/TableLoader';
import { Paper, Stack } from '@mui/material';

import EmptyPageTutorial from './EmptyPageTutorial';
import { useCurrentTemplateSections, useCurrentTemplatesQuery } from './hooks';
import PageContent from './PageContent';
import PageHeader from './PageHeader';
import { SectionsStoreProvider } from './SectionsStore';
import { SectionsToolbar } from './SectionsToolbar';

export default function WaypointTemplatesList() {
  const { data: templatesData } = useCurrentTemplatesQuery();
  const { data: sectionsData } = useCurrentTemplateSections();

  const templates = templatesData?.WaypointTemplates;
  const sections = sectionsData?.TemplateSections;

  const renderBody = () => {
    if (templates === undefined || sections === undefined) {
      return <TableLoader />;
    }

    if (templates.count === 0 && sections.length === 0) {
      return <EmptyPageTutorial />;
    }

    return (
      <SectionsStoreProvider sections={sections} templates={templates.nodes}>
        <SectionsToolbar />
        <PageContent sections={sections} templates={templates.nodes} />
      </SectionsStoreProvider>
    );
  };

  return (
    <Paper component={Stack}>
      <PageHeader />
      <Stack gap={2} p={2}>
        {renderBody()}
      </Stack>
    </Paper>
  );
}
